<template>
  <div>      
    <div style="text-align:center;padding-bottom:5px;">
      <div><img src="../assets/nexa/logo.png" width="100"></div>
      <div style="margin-top:10px;"><h4>Återställ lösenord</h4></div>
    </div>

    <div :style="styleObject">
      <div class="ok" v-if="didSendCode">Vi har nu skickat ett mejl till den e-posten du angav, tryck på länken i detta mejl för att fortsätta med återställninge.</div>
      
      <div v-if="!didSendCode">
                
        <div v-if="errorMessage.length">
          <span style="color:red;margin-bottom:10px;">{{ errorMessages[errorMessage] }}</span>
        </div>

        <div class="item">
          <input type="text" v-model="email" placeholder="E-post" :disabled="gotCode">
        </div>
        
        <div class="item" v-if="gotCode">
          <input type="password" v-model="password" placeholder="Lösenord">
        </div>
            
        <div class="item" v-if="gotCode">
          <input type="password" v-model="confirmPassword" placeholder="Bekräfta lösenord" >
        </div>
        
        <div class="descr" v-if="gotCode">Ditt lösenord måste vara <i>minst</i> 4 tecken långt, desto längre desto bättre.</div>
        
        <div v-if="gotCode"><button @click="reset" :disabled="!ok">{{ loading ? 'Återställer...' : 'Återställ nu' }}</button></div>
        <div v-if="!gotCode"><button @click="sendResetCode" :disabled="!ok">{{ loading ? 'Återställer...' : 'Begär återställningskod' }}</button></div>
        <div v-if="!gotCode" style="margin-top:5px;"><button @click="back">Gå tillbaka</button></div>
        </div>
    </div>

  </div>
</template>

<script>
  import { SpringSpinner } from 'epic-spinners'
  import { cloud } from '../http.js'
  import { eventbus } from '../eventbus.js'

  export default {
    name: 'resetpass',
    components: {
      SpringSpinner
    },
    data () {
      return {
        email: '',
        password: '',
        confirmPassword: '',
        loading: false,
        didSendCode: false,
        errorMessage: '',
        code: '',
        errorMessages: {
          BadAccount: 'Felaktig e-post eller återställningskod',
          RateLimited: 'För många återställningsförsök. Försök igen senare'
        }
      }
    },
    watch:{
      '$route' (to, from){
        if (to.name === 'resetpass_code') {
          const { code } = to.params

          cloud.get('account/resetpassCode?code=' + code).then(res => {
            const d = res.data
            if (d.success) {
              this.email = d.email
              this.code = code
              this.didSendCode = false
            }
          })
        }
      }
    },
    async created () {
      if ('code' in this.$route.params) {
        const d = (await cloud.get('account/resetpassCode?code=' + this.$route.params.code)).data

        if (d.success) {
          this.email = d.email
        }
      }
    },
    methods: {
      back () {
        this.$router.go(-1)
      },
      reset () {
        this.loading = true

        cloud.post('account/resetpass', {
          code: this.$route.params.code,
          password: this.password
        })
        .then(res => res.data)
        .then(json => {
          if (json.cloudResult === 'OK') {
            window.location = '/'
          } else {
            this.loading = false
            this.errorMessage = json.cloudResult
            setTimeout(() => this.errorMessage = '', 5000)
          }
        })
      },

      sendResetCode () {
        this.loading = true
        
        cloud.post('account/resetpassRequest?email=' + this.email)
        .then(res => res.data)
        .then(json => {
          this.loading = false
          
          if (json.cloudResult === 'OK') {
            this.didSendCode = true
          } else {
            this.errorMessage = json.cloudResult
            setTimeout(() => this.errorMessage = '', 5000)
          }
        })
      }
    },
    computed: {
      gotCode () {
        return ('code' in this.$route.params) || this.code.length > 0
      },

      ok () {
        if (!this.gotCode) {
          return this.email.length && this.email.includes('@') && this.email.includes('.') && !this.loading
        }

        return this.email.length && this.password.length > 4 && (this.password === this.confirmPassword) && !this.loading
      },
      
      styleObject () {
        return {
          border: (!this.working ? '1px solid #e7e7e7' : '0px'),
          width: '350px',
          'border-radius': '4px',
          padding: '12px'
        }
      }
    }
  }
</script>

<style scoped>
  .item {
    padding-bottom:7px;
  }
  
  .center {
    display:flex;
    justify-content:center;
    align-items:center;
  }
  
  .descr {
    font-size:12px;
    margin-bottom:10px;
  }
  
  .ok {
    border:1px solid #27ae60;
    background:rgba(39, 174, 96, 0.14);
    padding:6px;
    font-size:13px;
  }
</style>


// WEBPACK FOOTER //
// src/components/resetpass.vue